import { AbstractReportPmsApiService } from '../abstract-report.service';
import { RoomAssignments } from "../../../models/reports/daily-activity/room-assignments.model";

/**
 * @class RoomAssignmentsPmsApiService
 * @extends {AbstractReportPmsApiService<RoomAssignments>}
 */
export class RoomAssignmentsPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/daily-activity/room-assignments';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {RoomAssignments}
     * @protected
     */
    newModel(attributes, ...params) {

        return new RoomAssignments(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Feedback>>}
     */
    get(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    newPaginationCollection(paginationData, ...params) {
        return {
          perPageOptions: [10, 25, 50, 100],
          perPage: paginationData.per_page,
          page: paginationData.current_page,
          total: paginationData.total,
          from: paginationData.from,
          to: paginationData.to,
          models: paginationData.data.map((attributes) =>
            this.newModel(attributes, ...params)
          ),
          pageTotalRow: paginationData.page_total_row,
          //allPagesTotalRow: paginationData.all_pages_total_row
        };
      }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/reports/daily-activity/room-assignments.service.js